




















































import Vue from 'vue';
import Component from 'vue-class-component';
import TicketForm from '@/components/tickets/tickets-form/TicketForm.vue';
import { EventBus } from '@/main';
import { EventBusMessages } from '@/modules/shared/shared/domain/constants/event-bus-messages';
import { layout } from '@/modules/shared/shared/store/namespaces';
import { LayoutMutations } from '@/modules/shared/layouts/store/layout.mutations';
import { LayoutTitle } from '@/modules/shared/layouts/domain/layout-title';
import ManagementManagedServicesGeneralInformation from '@/modules/tickets/requirement/management-managed-services/components/ManagementManagedServicesGeneralInformation.vue';
import ManagementManagedServicesTicketConfirmation from '@/modules/tickets/requirement/management-managed-services/components/ManagementManagedServicesTicketConfirmation.vue';
import { managementAndManagedServices } from '@/modules/tickets/shared/store/namespaces';
import { ManagementManagedServicesGetters } from '@/modules/tickets/requirement/management-managed-services/store/management-managed-services.getters';
import { Typing } from '@/modules/tickets/shared/domain/typing';
import { ManagementManagedServicesActions } from '@/modules/tickets/requirement/management-managed-services/store/management-managed-services.actions';
import { ManagementManagedServicesData } from '@/modules/tickets/requirement/management-managed-services/domain/management-managed-services-data';

@Component({
    name: 'management-managed-services',
    components: {
        ManagementManagedServicesTicketConfirmation,
        ManagementManagedServicesGeneralInformation,
        TicketForm,
    },
})
export default class ManagementManagedServices extends Vue {
    private currentStep: number = 1;
    private isValid: boolean = true;
    private highestStepReached: number = 1;
    private isMounted = false;

    async mounted() {
        EventBus.$emit(EventBusMessages.SHOW_LOADER);

        this.changeTitle({
            title: 'Requerimiento de Gestión y Servicios Administrados',
            route: ['TICKETS'],
        });

        const failed = await this.fetchView();

        if (failed) {
            failed.showError();
        }

        this.isMounted = true;
        EventBus.$emit(EventBusMessages.HIDE_LOADER);
    }

    async sendRequirementTicket() {
        EventBus.$emit(EventBusMessages.SHOW_LOADER);
        const failed = await this.createTicket(this.formValues.generalInformation);
        if (failed) {
            failed.showError();
        } else {
            this.$router.push({
                name: 'tickets',
            });
        }
        EventBus.$emit(EventBusMessages.HIDE_LOADER);
    }

    nextStep() {
        if (this.currentStep < 2) {
            this.currentStep++;
            this.highestStepReached = this.currentStep;
        }
    }

    previousStep() {
        if (this.currentStep > 1) {
            this.currentStep--;
        }
    }

    @layout.Mutation(LayoutMutations.CHANGE_TITLE)
    changeTitle!: (title: LayoutTitle) => void;

    @managementAndManagedServices.Getter(ManagementManagedServicesGetters.GET_FORM_VALUES)
    formValues!: {
        generalInformation: ManagementManagedServicesData;
        typings: Typing[];
    };

    @managementAndManagedServices.Action(ManagementManagedServicesActions.FETCH_VIEW)
    fetchView!: () => Promise<RequestResponse>;

    @managementAndManagedServices.Action(ManagementManagedServicesActions.CREATE_TICKET)
    createTicket!: (information: ManagementManagedServicesData) => Promise<RequestResponse>;
}
